import React from 'react';
import styled from 'styled-components'

export default function Teacher({teacher, big = false}) {

    if(!teacher) return null
    return (
        <TeacherContainer big={big}>
            {teacher.profile_picture && <TeacherImage big={big} src={teacher.profile_picture} />}
            <TeacherName big={big}>{teacher.name}</TeacherName>
        </TeacherContainer>
    )
}


const TeacherContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 12px;
`
const TeacherImage = styled.img`
    width: ${props => props.big ? 120 : 60}px;
    border-radius: 120px;
    margin:auto;
`

const TeacherName = styled.div`
    font-size: ${props => props.big ? 14 : 10}px;
    text-align:center;
    padding-top: ${props => props.big ? 12 : 4}px;
`
